module.exports = __webpack_public_path__ + "img/2025big13.da5b65ed.jpg";